import React, { useState, useEffect } from "react";
import {
  Table,
  Container,
  Badge,
  TabContent,
  TabPane,
} from "reactstrap";
import { useParams } from "react-router-dom";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService";
import echo from "../../echo"; // 🔥 ADD

import UploadDocumentsModal from "../client/UploadDocumentsModal";

const DOCUMENT_TYPES = [
  "bank_statement",
  "invoice",
  "credit_card_statement",
  "hp_agreement",
  "corporation_tax",
  "financial_statement",
  "loan_statement",
  "nominal_ledger",
  "stock_statement",
  "mortgage_statement",
  "property_statement",
  "p32_payroll",
  "payroll_statement",
  "excel_gross_to_net",
];

const formatTypeLabel = (type) => {
  if (!type) return "";
  return type
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

/* ================= STATUS → CLASS LOGIC ================= */
const getStatusClass = (status) => {
  if (!status || status.trim() === "") {
    return "red-row";
  }

  const normalized = status.trim();

  const statusClassMap = {
    Completed: "blue-row",
    "In Progress": "orange-row blink-row",
    Pending: "orange-row",
    Received: "purple-row",
    Flagged: "yellow-row",
    Failed: "red-row",
  };

  return statusClassMap[normalized] || "red-row";
};

const TaskDocuments = () => {
  const { taskId } = useParams();

  const [documentlists, setDocumentLists] = useState([]);
  const [taskdetails, settaskdetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
const [editableDocs, setEditableDocs] = useState({});
const [processingId, setProcessingId] = useState(null);
const [downloadingFileId, setDownloadingFileId] = useState(null);
const [typeEditFileId, setTypeEditFileId] = useState(null);
const [typeEditValue, setTypeEditValue] = useState({ type: "", other: "" });
const [savingTypeId, setSavingTypeId] = useState(null);

  /* ================= S3 FOLDER BROWSER ================= */
  const [activeTab, setActiveTab] = useState("documents");
  const [browser, setBrowser] = useState(null); // { root, prefix, breadcrumbs, directories, files, message }
  const [browserLoading, setBrowserLoading] = useState(false);

  const loadFolder = (prefix = "") => {
    setBrowserLoading(true);
    taskmanageService
      .s3Browse(taskId, prefix)
      .then((response) => {
        setBrowser(response && response.data ? response.data : null);
      })
      .finally(() => setBrowserLoading(false));
  };

  const formatBytes = (bytes) => {
    if (bytes === null || bytes === undefined) return "";
    if (bytes < 1024) return `${bytes} B`;
    const units = ["KB", "MB", "GB"];
    let val = bytes / 1024;
    let i = 0;
    while (val >= 1024 && i < units.length - 1) {
      val /= 1024;
      i++;
    }
    return `${val.toFixed(1)} ${units[i]}`;
  };

  // Pick a Finder/Explorer-style icon + colour from a file name's extension.
  const fileIcon = (name = "") => {
    const ext = (name.split(".").pop() || "").toLowerCase();
    const map = {
      pdf: ["fa-file-pdf", "#e23c3c"],
      xls: ["fa-file-excel", "#1d7044"],
      xlsx: ["fa-file-excel", "#1d7044"],
      csv: ["fa-file-csv", "#1d7044"],
      doc: ["fa-file-word", "#2b579a"],
      docx: ["fa-file-word", "#2b579a"],
      png: ["fa-file-image", "#8e44ad"],
      jpg: ["fa-file-image", "#8e44ad"],
      jpeg: ["fa-file-image", "#8e44ad"],
      gif: ["fa-file-image", "#8e44ad"],
      html: ["fa-file-code", "#e67e22"],
      htm: ["fa-file-code", "#e67e22"],
      xml: ["fa-file-code", "#e67e22"],
      json: ["fa-file-code", "#e67e22"],
      zip: ["fa-file-archive", "#7f8c8d"],
      rar: ["fa-file-archive", "#7f8c8d"],
      txt: ["fa-file-alt", "#7f8c8d"],
    };
    const [icon, color] = map[ext] || ["fa-file", "#95a5a6"];
    return { icon, color };
  };

  const openFile = (f) => {
    // Open the presigned URL directly: the browser previews PDFs/images inline
    // and downloads Office files (which then open in desktop Excel/Word/etc.).
    // We can't hand presigned S3 URLs to the ms-excel:/ms-word: schemes because
    // Office probes the URL with non-GET requests the signature doesn't cover.
    window.open(f.url, "_blank", "noopener,noreferrer");
  };

  /* ================= FETCH DATA ================= */
  const fetchDocuments = () => {
  taskmanageService.getdocumentdetail(taskId).then((response) => {
    settaskdetails(response.data.data);
    setDocumentLists(response.data.files || []);
  });
};
  useEffect(() => {
    fetchDocuments();
  }, [taskId]);

  useEffect(() => {
    // if (!echo) return;
    console.log("🔌 Echo instance:", echo);
    const channel = echo.channel("documents");

    channel.subscribed(() => {
      console.log("✅ SUBSCRIBED to documents channel");
    });

    
    channel.listen(".status.updated", (e) => {
      console.log("📡 Status update received:", e.document);

      setDocumentLists((prev) =>
        prev.map((file) =>
          file.id === e.document.id
            ? { ...file, status: e.document.status }
            : file
        )
      );
       if (e.document.status === "Completed") {
          console.log("🔄 Refetching document details...");
          fetchDocuments();
          // If the Client Folder tab has been opened, refresh it — the file
          // just moved into the tree. (Guarded against a stale-closure null.)
          setBrowser((prev) => {
            if (prev) loadFolder();
            return prev;
          });
          setExpandedRow(e.document.id); // auto-open row
        }
    });



    channel.error((error) => {
      console.error("❌ Channel error:", error);
    });
    return () => {
      echo.leave("documents");
       console.log("👋 Left documents channel");
    };
  }, []);

  /* ================= HANDLERS ================= */
  const toggleRow = (id, hasDocuments) => {
    if (!hasDocuments) return;
    setExpandedRow(expandedRow === id ? null : id);
  };

  const downloadAllfile = (userid, taskid) => {
    setLoading(true);
    taskmanageService
      .download_all_fileS3(userid, taskid)
      .finally(() => setLoading(false));
  };

  const downloadSingleFile = (file) => {
    setDownloadingFileId(file.id);
    taskmanageService
      .download_file(file.doc_path, file.file_name, file.extension, file.id, file.s3_bucket)
      .finally(() => setDownloadingFileId(null));
  };

  const openDocumentView = (documentId) => {
    window.open(`/admin/document/view/${documentId}`, "_blank");
  };
const startTypeEdit = (file) => {
  const current = (file.document_type || "").trim();
  const isKnown = current && DOCUMENT_TYPES.includes(current);
  setTypeEditFileId(file.id);
  setTypeEditValue({
    type: isKnown ? current : (current ? "other" : ""),
    other: isKnown ? "" : current,
  });
};

const cancelTypeEdit = () => {
  setTypeEditFileId(null);
  setTypeEditValue({ type: "", other: "" });
};

const saveTypeEdit = async (file) => {
  const value =
    typeEditValue.type === "other"
      ? (typeEditValue.other || "").trim()
      : typeEditValue.type;

  try {
    setSavingTypeId(file.id);
    await taskmanageService.updateUploadDocType({
      file_id: file.id,
      document_type: value,
    });
    setDocumentLists((prev) =>
      prev.map((f) =>
        f.id === file.id ? { ...f, document_type: value || null } : f
      )
    );
    cancelTypeEdit();
  } catch (e) {
    console.error("Save type failed", e);
  } finally {
    setSavingTypeId(null);
  }
};

const enableEdit = (file) => {
  // 🔹 open row if not already open
  if (expandedRow !== file.id) {
    setExpandedRow(file.id);
  }

  setEditRowId(file.id);

  const docsMap = {};
  file.documents.forEach((doc) => {
    const isKnown = DOCUMENT_TYPES.includes(doc.document_type);
    docsMap[doc.id] = {
      type: isKnown ? doc.document_type : (doc.document_type ? "other" : ""),
      other: isKnown ? "" : (doc.document_type || ""),
    };
  });

  setEditableDocs(docsMap);
};

const updateDocType = (docId, value) => {
  setEditableDocs((prev) => ({
    ...prev,
    [docId]: { ...(prev[docId] || { other: "" }), type: value },
  }));
};

const updateDocOther = (docId, value) => {
  setEditableDocs((prev) => ({
    ...prev,
    [docId]: { ...(prev[docId] || { type: "other" }), other: value },
  }));
};

const reprocessDocument = async (file) => {
  try {
    setProcessingId(file.id);

    await taskmanageService.reprocessDocument({
      file_id: file.id,
      documents: Object.keys(editableDocs).map((id) => {
        const entry = editableDocs[id] || {};
        const value =
          entry.type === "other" ? (entry.other || "").trim() : entry.type;
        return { id, document_type: value };
      }),
    });

    setEditRowId(null);
    fetchDocuments(); // refresh table
  } catch (err) {
    console.error("Reprocess failed", err);
  } finally {
    setProcessingId(null);
  }
};

  return (
    <>
      <style>
        {`
        @keyframes blinkRow {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
        .blink-row {
          animation: blinkRow 1.2s infinite ease-in-out;
        }
      `}
      </style>

      <Header />
      <Container className="mt--7" fluid>
        <div className="mt-4" style={{ position: "relative", zIndex: 10 }}>
          {/* ================= TABS ================= */}
          <div
            style={{
              display: "flex",
              gap: "4px",
              borderBottom: "2px solid #e9ecef",
              marginBottom: "20px",
            }}
          >
            {[
              { id: "documents", label: "Documents", icon: "fa-file-alt" },
              { id: "folder", label: "Client Folder", icon: "fa-folder-open" },
            ].map((t) => {
              const active = activeTab === t.id;
              return (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => {
                    setActiveTab(t.id);
                    if (t.id === "folder" && !browser) loadFolder();
                  }}
                  style={{
                    border: "none",
                    background: "transparent",
                    padding: "10px 18px",
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: "pointer",
                    color: active ? "#5e72e4" : "#8898aa",
                    borderBottom: active ? "2px solid #5e72e4" : "2px solid transparent",
                    marginBottom: "-2px",
                  }}
                >
                  <i className={`fas ${t.icon} mr-2`}></i>
                  {t.label}
                </button>
              );
            })}
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="documents">
          <button className="btn btn-primary mb-3" onClick={() => setShowUploadModal(true)}>
            Upload Document
          </button>
          {loading ? (
            <p style={{ color: "#5d6cae" }}>Downloading please wait…</p>
          ) : (
            <button
              onClick={() =>
                downloadAllfile(taskdetails.user_id, taskdetails.id)
              }
              className="btn btn-secondary mb-3"
            >
              <i className="fas fa-download"></i> Download All Original Documents
            </button>
          )}

          <Table bordered responsive>
            <thead>
              <tr>
                <th>Uploaded File</th>
                <th>Type</th>
                <th>Date</th>
                <th>AI Extraction Status</th>
                <th>Document Owner</th>
                <th>Document Date range</th>
                <th>Download</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {documentlists.length ? (
                documentlists.map((file) => {
                  const hasDocuments =
                    Array.isArray(file.documents) &&
                    file.documents.length > 0;

                  return (
                    <React.Fragment key={file.id}>
                      <tr
                        className={getStatusClass(file.status)}
                        style={{ cursor: hasDocuments ? "pointer" : "default" }}
                        onClick={() => toggleRow(file.id, hasDocuments)}
                      >
                        <td>
                          {hasDocuments && (
                            <i
                              className={`fas ${
                                expandedRow === file.id
                                  ? "fa-chevron-down"
                                  : "fa-chevron-right"
                              } mr-2`}
                            ></i>
                          )}
                          {file.file_name}.{file.extension}
                        </td>

                        <td onClick={(e) => e.stopPropagation()}>
                          {typeEditFileId === file.id ? (
                            <>
                              <select
                                className="form-control form-control-sm"
                                value={typeEditValue.type}
                                onChange={(e) =>
                                  setTypeEditValue((prev) => ({
                                    ...prev,
                                    type: e.target.value,
                                  }))
                                }
                              >
                                <option value="">-- Select Type --</option>
                                {DOCUMENT_TYPES.map((t) => (
                                  <option key={t} value={t}>
                                    {formatTypeLabel(t)}
                                  </option>
                                ))}
                                <option value="other">Other</option>
                              </select>
                              {typeEditValue.type === "other" && (
                                <input
                                  type="text"
                                  className="form-control form-control-sm mt-1"
                                  placeholder="Enter document type"
                                  value={typeEditValue.other}
                                  onChange={(e) =>
                                    setTypeEditValue((prev) => ({
                                      ...prev,
                                      other: e.target.value,
                                    }))
                                  }
                                />
                              )}
                              <div className="mt-1">
                                <button
                                  className="btn btn-success btn-sm"
                                  disabled={savingTypeId === file.id}
                                  onClick={() => saveTypeEdit(file)}
                                >
                                  {savingTypeId === file.id ? "Saving..." : "Save"}
                                </button>
                                <button
                                  className="btn btn-secondary btn-sm ml-1"
                                  onClick={cancelTypeEdit}
                                >
                                  Cancel
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <span>
                                {file.document_type
                                  ? file.document_type
                                      .split(",")
                                      .map((t) => t.trim())
                                      .filter(Boolean)
                                      .map((t) =>
                                        DOCUMENT_TYPES.includes(t)
                                          ? formatTypeLabel(t)
                                          : t
                                      )
                                      .join(", ")
                                  : "-"}
                              </span>
                              <button
                                className="btn btn-link btn-sm p-0 ml-2"
                                onClick={() => startTypeEdit(file)}
                                title="Edit type"
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                            </>
                          )}
                        </td>
                        <td>{file.date}</td>
                        <td>
                            <Badge style={{
                                  backgroundColor:
                                    file.status === "Completed"
                                      ? "#28a745"
                                      : file.status === "In Progress" || file.status === "Received" || file.status === "Pending"  
                                      ? "#ffc107"
                                      : "#dc3545",
                                  color: "#fff",
                                }}>
                              {file.status}
                            </Badge>
                          </td>
                          <td>{file.owner}</td>
                          <td>{file.doc_date_range}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {downloadingFileId === file.id ? (
                            <span style={{ color: "#5d6cae" }}>
                              <i className="fas fa-spinner fa-spin"></i> Downloading…
                            </span>
                          ) : (
                            <a
                              style={{ cursor: "pointer", color: "#5d6cae" }}
                              onClick={() => downloadSingleFile(file)}
                            >
                              <i className="fas fa-download"></i> Download
                            </a>
                          )}
                        </td>
                      <td onClick={(e) => e.stopPropagation()}>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => enableEdit(file)}
                      disabled={!hasDocuments}
                    >
                      <i className="fas fa-edit"></i> Edit
                    </button>
                          {editRowId === file.id && (
                            <div className="mt-2 text-right">
                              <button
                                className="btn btn-success btn-sm"
                                disabled={processingId === file.id}
                                onClick={() => reprocessDocument(file)}
                              >
                                {processingId === file.id ? (
                                  "Processing..."
                                ) : (
                                  <>
                                    <i className="fas fa-sync"></i> Reprocess
                                  </>
                                )}
                              </button>

                              <button
                                className="btn btn-secondary btn-sm ml-2"
                                onClick={() => setEditRowId(null)}
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        </td>

                      </tr>

                      {expandedRow === file.id && hasDocuments && (
                        <tr className={getStatusClass(file.status)}>
                          <td colSpan="8">
                            <Table size="sm" style={{ marginBottom: "0" }}>
                              <tbody>
                                {file.documents.map((doc) => (
                                  <tr
                                    key={doc.id}
                                   
                                  >
                                    <td>
                                      {editRowId === file.id ? (
                                        <>
                                          <select
                                            className="form-control form-control-sm"
                                            value={(editableDocs[doc.id] && editableDocs[doc.id].type) || ""}
                                            onChange={(e) =>
                                              updateDocType(doc.id, e.target.value)
                                            }
                                          >
                                            <option value="">-- Select Type --</option>
                                            {DOCUMENT_TYPES.map((t) => (
                                              <option key={t} value={t}>
                                                {formatTypeLabel(t)}
                                              </option>
                                            ))}
                                            <option value="other">Other</option>
                                          </select>
                                          {editableDocs[doc.id] &&
                                            editableDocs[doc.id].type === "other" && (
                                              <input
                                                type="text"
                                                className="form-control form-control-sm mt-1"
                                                placeholder="Enter document type"
                                                value={editableDocs[doc.id].other || ""}
                                                onChange={(e) =>
                                                  updateDocOther(doc.id, e.target.value)
                                                }
                                              />
                                            )}
                                        </>
                                      ) : (
                                        DOCUMENT_TYPES.includes(doc.document_type)
                                          ? formatTypeLabel(doc.document_type)
                                          : doc.document_type
                                      )}
                                    </td>

                                  
                                    {/* <td>{doc.created_at}</td> */}
                                    <td>
                                      <Badge style={{
                                            backgroundColor:
                                              file.status === "Completed"
                                                ? "#28a745"
                                                : file.status === "In Progress" || file.status === "Received" || file.status === "Pending"  
                                                ? "#ffc107"
                                                : "#dc3545",
                                            color: "#fff",
                                          }}>
                                        {file.status}
                                      </Badge>
                                    </td>
                                    <td onClick={() => openDocumentView(doc.id)}><i className="fas fa-eye"></i> View AI extraction</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8">No Data Found</td>
                </tr>
              )}
            </tbody>
          </Table>
            </TabPane>

            <TabPane tabId="folder">
          {/* ================= S3 FOLDER BROWSER ================= */}
          <div className="mt-2">
            <div className="d-flex align-items-center mb-2">
              <h4 className="mb-0">Client Folder</h4>
              <button
                className="btn btn-link btn-sm ml-2 p-0"
                onClick={() => loadFolder(browser ? browser.prefix : "")}
                title="Refresh"
              >
                <i className="fas fa-sync"></i>
              </button>
            </div>

            {browserLoading ? (
              <p style={{ color: "#5d6cae" }}>
                <i className="fas fa-spinner fa-spin"></i> Loading folder…
              </p>
            ) : !browser || browser.root === null ? (
              <p className="text-muted">
                {(browser && browser.message) ||
                  "No client folder available for this task yet."}
              </p>
            ) : (
              <>
                {/* Breadcrumbs */}
                <div className="mb-2">
                  {(browser.breadcrumbs || []).map((crumb, idx) => (
                    <span key={crumb.prefix}>
                      {idx > 0 && <span className="mx-1 text-muted">/</span>}
                      <a
                        style={{ cursor: "pointer", color: "#5d6cae" }}
                        onClick={() => loadFolder(crumb.prefix)}
                      >
                        {crumb.name}
                      </a>
                    </span>
                  ))}
                </div>

                {/* Explorer-style icon grid */}
                {!(browser.directories || []).length &&
                !(browser.files || []).length ? (
                  <div className="text-center text-muted py-5">
                    <i className="fas fa-folder-open fa-3x mb-2 d-block" style={{ opacity: 0.4 }}></i>
                    This folder is empty.
                  </div>
                ) : (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
                      gap: "12px",
                    }}
                  >
                    {(browser.directories || []).map((dir) => (
                      <div
                        key={dir.prefix}
                        onClick={() => loadFolder(dir.prefix)}
                        title={dir.name}
                        style={{
                          cursor: "pointer",
                          textAlign: "center",
                          padding: "14px 6px",
                          borderRadius: "8px",
                          border: "1px solid #eef0f5",
                          background: "#fafbfe",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#eef1fb")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fafbfe")}
                      >
                        <i
                          className="fas fa-folder d-block"
                          style={{ fontSize: "44px", color: "#f6c244", marginBottom: "8px" }}
                        ></i>
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#32325d",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                          }}
                        >
                          {dir.name}
                        </div>
                      </div>
                    ))}

                    {(browser.files || []).map((f) => {
                      const { icon, color } = fileIcon(f.name);
                      return (
                        <div
                          key={f.key}
                          onClick={() => openFile(f)}
                          title={f.name}
                          style={{
                            textAlign: "center",
                            padding: "14px 6px",
                            borderRadius: "8px",
                            border: "1px solid #eef0f5",
                            background: "#fff",
                            textDecoration: "none",
                            display: "block",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#f6f7fb")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                        >
                          <i
                            className={`fas ${icon} d-block`}
                            style={{ fontSize: "44px", color, marginBottom: "8px" }}
                          ></i>
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#32325d",
                              wordBreak: "break-word",
                              lineHeight: "1.2",
                            }}
                          >
                            {f.name}
                          </div>
                          <div style={{ fontSize: "11px", color: "#8898aa", marginTop: "2px" }}>
                            {formatBytes(f.size)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
            </TabPane>
          </TabContent>
        </div>
        <UploadDocumentsModal
                  isOpen={showUploadModal}
                  jobId={taskId}
                  onClose={() => {
                    setShowUploadModal(false);
                    // setDisableBtn(false);
                  }}
                  onSuccess={() => {
                    setShowUploadModal(false);
                    fetchDocuments(); // ✅ REFRESH LIST
                  }}
                />
      </Container>
       
    </>
  );
};

export default TaskDocuments;
